function getActivityMinimumAge(activity) {
    const raw =
        activity?.minimum_age ??
        activity?.min_age ??
        activity?.age_minimum ??
        activity?.minimum_required_age ??
        activity?.min_required_age ??
        null;

    const n = Number(raw);
    if (!Number.isFinite(n) || n <= 0) return 0;
    return Math.max(0, Math.floor(n));
}

function getAgePillClass(minimumAge) {
    if (minimumAge >= 16) return "activity-card-age-pill activity-card-age-pill--adult";
    if (minimumAge > 0) return "activity-card-age-pill activity-card-age-pill--restricted";
    return "activity-card-age-pill";
}


function getActivityDisplaySection(activity) {
    return String(activity?.display_section || "").trim().toLowerCase();
}

function isPassPerkActivity(activity) {
    const section = getActivityDisplaySection(activity);
    return section === "pass_perks" || activity?.is_pass_perk === true;
}

function formatDuration(value) {
    const duration = value ?? 1;
    const numeric = Number(duration);

    if (!Number.isFinite(numeric)) return `${duration} hrs`;
    if (numeric === 1) return "1 hr";

    return `${numeric} hrs`;
}

export default function ActivityCard({ activity, onView }) {
    const duration = activity.duration_hours ?? activity.duration ?? 1;
    const minimumAge = getActivityMinimumAge(activity);
    const requiresReservation = !!activity.requires_reservation;
    const isPassPerk = isPassPerkActivity(activity);

    const imageSrc = activity.image_url || activity.image || "/assets/Graphics/Hero_New.png?v=2";

    const category = activity.category || (isPassPerk ? "Pass Perk" : "Adventure");

    const statusClass = requiresReservation ? "is-reservation" : "is-scan";

    return (
        <article className={`activity-card activity-card--${statusClass.replace("is-", "")}`}>
            <div className="activity-card-media">
                <img
                    src={imageSrc}
                    alt={activity.name || "Beach Bum Pass activity"}
                    className="activity-card-img"
                    loading="lazy"
                />

            </div>

            <div className="activity-card-content">
                {/* <div className="activity-card-topline">
                    <span>{category}</span>
                </div> */}

                <h3>{activity.name}</h3>

                {activity.location ? (
                    <p className="activity-location">{activity.location}</p>
                ) : null}

                {!isPassPerk ? (
                    <p className="activity-duration">
                        Duration: <strong>{formatDuration(duration)}</strong>
                    </p>
                ) : null}



                <div className="activity-card-buttons">
                    <button
                        type="button"
                        onClick={() => onView?.(activity)}
                        className="btn-primary activity-card-btn"
                    >
                        View Details
                    </button>
                </div>
            </div>
        </article>
    );
}